import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';

/**
 * Email validator that ignores leading and trailing whitespace.
 * The field is trimmed on blur and again before the API request.
 */
export function trimmedEmailValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  if (typeof value !== 'string') {
    return Validators.email(control);
  }
  const trimmed = value.trim();
  if (!trimmed || trimmed === value) {
    return Validators.email(control);
  }
  return Validators.email({ value: trimmed } as AbstractControl);
}
